import _ from 'lodash';

import { usePermissionContext, useWorkspaceContext } from '../context';

export enum JobBoardsAction {
  FREE_JOB_BOARDS = 'FREE_JOB_BOARDS',
  PREMIUM_JOB_BOARDS = 'PREMIUM_JOB_BOARDS',
  CAREER_PAGES = 'CAREER_PAGES',
  TEAM_ASSIGNMENT = 'TEAM_ASSIGNMENT',
  USER_ASSIGNMENT = 'USER_ASSIGNMENT',
  CREATE_CLIENT = 'CREATE_CLIENT',
  CREATE_CLIENT_SPOC = 'CREATE_CLIENT_SPOC',
  DOWNLOAD_JOBS = 'DOWNLOAD_JOBS',
  POTENTIAL_REVENUE_VISIBILITY = 'POTENTIAL_REVENUE_VISIBILITY',
}

export const useJobAccessControl = (actions: JobBoardsAction[]) => {
  const workspace = useWorkspaceContext();
  const permissionContext = usePermissionContext();
  const data = actions.map(
    (action) =>
      !_.isEmpty(workspace.role) &&
      permissionContext.isAuthorized &&
      permissionContext.isAuthorized('JOB_BOARD', action, [workspace.role ?? ''])
  );
  return { access: data, owns: workspace.owns };
};
